function AppTitle(props) {
    return (
      <h3 className="col text-center">{props.title}</h3>
    );
  }
  
  export default AppTitle;
  